import './panel-form.scss'
import FormGrid from './FormGrid';
export default {
	name: 'lnk-form-panel',
	mixins: [FormGrid],
	props:{
		/*是否不要头部*/
		noHeader:{
			type:Boolean,
			default: false
		},
		/*是否始终禁用*/
		disabled:{
			type:Boolean,
			default: undefined
		},
		/*配置对象*/
		option: Object
	},
	render(){
		const vm = this;
		return (
			<div class="lnk-form-panel">
				{
					vm.showHeader
						? <div class={['form-header', {'no-buttons': !vm.hasBtns}]}>
							<div class="form-header-left">
								{vm.title ? <span class="header-label">{vm.title}</span> : vm._e()}
								{vm._t('header-left')}
							</div>
							<div class="form-header-right">
								{
									vm.isEditing
										? <span class="is-editing">{vm._t('header-right-editing')}</span>
										: <span v-else class="is-reading">{vm._t('header-right-reading')}</span>
								}
							</div>
						</div> : vm._e()
				}
				<div class={['form-body', {'single-col-form' : vm.isSingleCol }]}>
					{vm._t("form-pre")}
					<el-form ref="elForm"
							 {...vm.elFormProps}>
						{vm.isSingleCol ?  vm._t('default') : vm._patch_grid(vm._t('default'))}
					</el-form>
					{vm._t("form-succ")}
				</div>
			</div>
		);
	},
	computed:{
		myOption(){
			const option =  this.option || new FormOption({});
			if(option instanceof FormOption){
				option.bindFormPanel(this)
			}
			return option;
		},
		/*标题*/
		title(){
			return this.myOption.title
		},
		/*右上角是否有按钮*/
		hasBtns(){
			return this.$slots['header-right-editing']
				|| this.$slots['header-right-reading'];
		},
		/*是否显示头部*/
		showHeader(){
			if(this.noHeader) return false;
			if(!this.title && !this.$slots['header-left'] && !this.hasBtns){
				return false;
			}
			return true;
		},
		/*是否单列*/
		isSingleCol(){
			return this.myOption.isSingleCol;
		},
		/*是否在编辑*/
		isEditing(){
			return this.myOption.isEditing;
		},
		/*是否禁用*/
		isDisabled(){
			if(this.disabled !== undefined) return this.disabled;
			return !this.isEditing;
		},
		/*el-form的绑定属性*/
		elFormProps(){
			let props = this.myOption.elFormProps || {};
			props = {...props};
			if(this.isSingleCol){
				props.labelWidth = 'calc(50% - 200px)';
				props.size = 'small';
			}
			props.labelWidth = props.labelWidth || '100px';
			props.size = props.size || 'mini';
			props.model = this.myOption.data;
			props.disabled = this.isDisabled;
			return {props}
		}
	},
	beforeDestroy() {
		if(this.myOption instanceof FormOption){
			this.myOption.unBindFormPanel(this);
		}
	}
}
